// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3e8cc11d","977":"f7c0fda7"}[chunkId] + ".chunk.js";
};